export default __webpack_public_path__ + "static/media/SparkleLeft.370d7505.svg";